import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Global from '../../store/global-selectors';
import { toggleNotificationHub } from '../../store/notification-hub/notification-hub.actions';
import { useEnableNotificationHub } from '../../feature-flags/hooks/use-enable-notification-hub';
import { NotificationHubContent } from './components/notification-hub-content';
import style from './style.module.less';

const NotificationHub = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(Global.selectNotificationHubIsOpen) ?? false;

  const handleToggleHub = useCallback(() => {
    dispatch(toggleNotificationHub(!isOpen));
  }, [dispatch, isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={style['notification-hub-wrapper']}>
      <NotificationHubContent onToggleHub={handleToggleHub} />
    </div>
  );
};

export const NotificationHubGate = () => {
  const isNotificationHubEnabled = useEnableNotificationHub();

  if (!isNotificationHubEnabled) {
    return null;
  }

  return <NotificationHub />;
};
